<div class="patient-test-fill">
	@if (res?.filled) {
		<p>{{ "patient_filled_details" | langVal }}</p>
	} @else {
		@if (submitted) {
			<p>{{ "thank_you_for_filling" | langVal }}</p>
			<!--      {{res.name}}-->
		} @else {
			@if (res) {
				<p class="instruct">
					{{ "you_are_invited_by" | langVal }} {{ res.user_name }}
					{{ "to_patient_fill_form" | langVal }}
				</p>
			}

			@if (res?.patient_details_fields_manage?.name?.show) {
				<div>
					<label>{{ "patient_name" | langVal }}</label>
					<app-gen-input
						tabindex="1"
						autofocus="autofocus"
						[actualObj]="patient"
						[errors]="errors"
						fieldName="name"
						title_ph_lang="patient_name"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}
			@if (res?.patient_details_fields_manage?.id_number?.show) {
				<div>
					<label>{{ "id_number" | langVal }}</label>
					<app-gen-input
						tabindex="2"
						[actualObj]="patient"
						[errors]="errors"
						fieldName="id_number"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}
			@if (res?.patient_details_fields_manage?.email?.show) {
				<div>
					<label>{{ "email" | langVal }}</label>
					<app-gen-input
						tabindex="3"
						[actualObj]="patient"
						[errors]="errors"
						fieldName="email"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}
			@if (res?.patient_details_fields_manage?.phone?.show) {
				<div>
					<label>{{ "phone" | langVal }}</label>
					<app-gen-input
						tabindex="4"
						[actualObj]="patient"
						[errors]="errors"
						fieldName="phone"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}
			@if (res?.patient_details_fields_manage?.date_of_birth?.show) {
				<div>
					<label>{{ "date_of_birth" | langVal }}</label>
					<app-date-picker
						[actualObj]="patient"
						[errors]="errors"
						fieldName="date_of_birth"
						startFromDecade
						isFullYear
						tabindex="-1"
						(changeEvent)="validateEntireForm()"
						[addonObject]="{ after: { icon: 'calendar' } }"
					/>
				</div>
			}

			@if (res?.patient_details_fields_manage?.marital_status?.show) {
				<div>
					<label>{{ "marital_status" | langVal }}</label>
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="marital_status"
						optionsListName="marital_status_opts"
						(changeEvent)="validateEntireForm()"
						[errors]="errors"
					/>
				</div>
			}
			@if (res?.patient_details_fields_manage?.gender?.show) {
				<div>
					<label>{{ "gender" | langVal }}</label>
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="gender"
						optionsListName="gender_opts"
						(changeEvent)="validateEntireForm()"
						[errors]="errors"
					/>
				</div>
			}
			@if (res?.patient_details_fields_manage?.remarks?.show) {
				<div>
					<label>{{ "remarks" | langVal }}</label>
					<app-ta-expands
						tabindex="5"
						[actualObj]="patient"
						[errors]="errors"
						fieldName="remarks"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			}

			@for (patientfield of patientfields; track patientfield.id) {
				<div>
					<label>{{ patientfield.name | langVal }}</label>
					@switch (patientfield.type) {
						@case ("text") {
							<app-ta-expands
								[actualObj]="patient"
								[errors]="errors"
								[fieldName]="patientfield.fieldName"
								[title_ph_lang]="patientfield.name"
								(keyupEvent)="validateEntireForm()"
							/>
						}
						@case ("opts-checkbox") {
							<div
								class="d-grid gap-2"
								style="margin-inline-start: 8px; padding-top: 4px"
							>
								@for (opt of patientfield.optsArr; track opt) {
									<p class="d-flex flex-nowrap align-items-start gap-2">
										<input
											type="radio"
											[name]="patientfield.fieldName"
											(click)="
												patient[patientfield.fieldName] = opt.value;
												validateEntireForm()
											"
											[checked]="patient[patientfield.fieldName] == opt.value"
										/>
										{{ opt.value }}
									</p>
								}
							</div>
						}
						@case ("opts-btn-group") {
							<app-gen-button-group
								[actualObj]="patient"
								[fieldName]="patientfield.fieldName"
								optionFieldValue="value"
								optionFieldName="value"
								[errors]="errors"
								[options]="patientfield.optsArr"
								(changeEvent)="validateEntireForm()"
							/>
						}
					}
				</div>
			}

			<div class="modal-btns justify-content-center pt-4">
				<app-btn-ext
					text="close_btn"
					[disabled]="!isFormSubmittable"
					tabindex="10"
					(clickEv)="save()"
					[isSpin]="isSaving"
				/>
			</div>
		}
	}
</div>
